import { createContext, useContext } from 'react'
import { ReactState } from '../types/ReactState';

export const GitlabAccessTokenContext = createContext<ReactState<string>>(null)

export function useGitlabAccessToken(): ReactState<string> {
    const [accessToken, setAccessToken] = useContext(GitlabAccessTokenContext)
    return [
        accessToken,
        (newToken: string) => {
            localStorage.setItem("GitLabAccessToken", newToken)
            setAccessToken(newToken)
        }
    ]
}
